import { initState } from './common';
import usersApiClient from "./UsersApiClient";
;
;
;
const initLoginRequest = {
    Email: '',
    Password: '',
};
export function getLoginData(goToRoot = false) {
    return {
        ...initState,
        loginData: initLoginRequest,
        isLoading: false,
        isReturningMember: false,
        errorMessage: '',
        submit(_, isMobile = false) {
            this.isLoading = true;
            usersApiClient.login(this.loginData)
                .then((data) => {
                this.isLoading = false;
                if (data.isReturningMember) {
                    this.isReturningMember = true;
                    return;
                }
                if (goToRoot) {
                    location.href = location.origin;
                    return;
                }
                const queryStrings = new URLSearchParams(location.search);
                const returnUrl = queryStrings.get("returnUrl");
                if (returnUrl) {
                    location.replace(returnUrl);
                    return;
                }
                if (isMobile) {
                    window.history.back();
                    return;
                }
                location.reload();
            })
                .catch((err) => {
                this.isLoading = false;
                if (err.status === 400) {
                    this.errorMessage = err.data[0].ErrorMessage;
                }
                else {
                    this.errorMessage = err.data.message != null
                        ? err.data.message
                        : err.data.Message;
                }
            });
        },
    };
}
